import { createFileRoute } from '@tanstack/react-router'
import { UserRound } from 'lucide-react'
import { ProfileScreen } from '@/screens/me/SCR-122-profile'

export const Route = createFileRoute('/_app/me/profile')({
  staticData: { screen: { id: 'SCR-122', title: 'Profile', group: 'Me', order: 4, description: 'Your name, photo and how ESM addresses you.', icon: UserRound } },
  component: ProfileScreen,
})
